import {Stack, Typography, IconButton, Tooltip} from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import CheckIcon from '@mui/icons-material/Check'
import { useState } from 'react'
import { AccountDetails } from '../Detail/OrderDetail'

interface Props {
    item: AccountDetails
}

export default function AccountDetail({item}: Props) {
    const [copiedField, setCopiedField] = useState<string | null>(null)

    const handleCopy = (val: string, key: string) => {
        navigator.clipboard.writeText(val)
        setCopiedField(key)
        setTimeout(() => setCopiedField(null), 2000)
    }

    return (
        <Stack spacing={2} p={1} sx={{ direction: 'rtl', width: '100%' }}>
            {item?.fields?.map((field) => (
                <Stack 
                    key={field.field_title}
                    direction="row" 
                    alignItems="center" 
                    justifyContent="space-between"
                    p={2}
                    sx={{
                        bgcolor: 'background.paper',
                        borderRadius: 2.5,
                        border: '1px solid rgba(255, 255, 255, 0.08)',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                    }}
                >
                    <Stack direction="row" alignItems="center" spacing={1.5} sx={{ overflow: 'hidden' }}>
                        <Typography 
                            variant="body1" 
                            sx={{
                                fontWeight: '600', 
                                color: 'text.secondary',
                                fontSize: '15px',
                                minWidth: '90px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {field.field_title}:
                        </Typography>
                        <Typography 
                            variant="body1" 
                            sx={{
                                fontWeight: '500', 
                                fontSize: '16px', 
                                color: 'text.primary', 
                                wordBreak: 'break-all',
                                fontFamily: 'monospace'
                            }}
                        >
                            {field.value}
                        </Typography>
                    </Stack>
                    <Tooltip title={copiedField === field.field_title ? "کپی شد!" : "کپی کردن"}>
                        <IconButton 
                            onClick={() => handleCopy(field.value, field.field_title)}
                            size="small"
                            color={copiedField === field.field_title ? "success" : "default"}
                            sx={{ 
                                mr: 1, 
                                border: '1px solid rgba(255, 255, 255, 0.1)',
                                bgcolor: copiedField === field.field_title ? 'rgba(46, 125, 50, 0.08)' : 'transparent',
                                '&:hover': {
                                    bgcolor: copiedField === field.field_title ? 'rgba(46, 125, 50, 0.15)' : 'rgba(255, 255, 255, 0.05)'
                                }
                            }}
                        >
                            {copiedField === field.field_title ? (
                                <CheckIcon fontSize="small" />
                            ) : (
                                <ContentCopyIcon fontSize="small" />
                            )}
                        </IconButton>
                    </Tooltip>
                </Stack>
            ))}
        </Stack>
    )
}
